import React from "react"
import PropTypes from "prop-types"

import "./Overlay.scss"

function Overlay(props) {
  if(!props.visible) {
    return null
  }

  return (
    <div 
      className={`c-overlay ${props.position}`}
      onClick={(e) => {
        if(e.target === e.currentTarget) {
          props.close()
        }
      }}
    >
      <div className="c-overlay-content">
        {props.children}
      </div>
    </div>
  )
}

Overlay.propTypes = {
  close:PropTypes.func.isRequired,
  closeOnClickOutside:PropTypes.bool.isRequired,
  visible:PropTypes.bool.isRequired,
  position:PropTypes.oneOf(["left", "fill", "center"])
}

Overlay.defaultProps = {
  closeOnClickOutside:true,
  position:"fill"
}

export default Overlay